import { forwardRef, useMemo } from 'react'
import { StepperProps } from './props'
import {
    StyledStepper,
    StyledCircle,
    CurrentStepLine,
    DefaultLine,
} from './styles'

const Stepper = forwardRef<HTMLDivElement, StepperProps>(
    ({ numberOfSteps, currentStep, ...props }, ref) => {
        const steps = useMemo(
            () =>
                Array.from(Array(numberOfSteps).keys()).map((number) => (
                    <StyledCircle
                        key={number}
                        colored={currentStep - 1 >= number}
                    />
                )),
            [currentStep, numberOfSteps]
        )

        return (
            <StyledStepper {...props} ref={ref}>
                {steps}{' '}
                <CurrentStepLine
                    css={{
                        w: `${
                            (100 / (numberOfSteps - 1)) * (currentStep - 1)
                        }%`,
                    }}
                />
                <DefaultLine />
            </StyledStepper>
        )
    }
)

Stepper.displayName = 'Stepper'

export default Stepper
export { StyledStepper }
